
angular.module('app.shared.clipSortService', [

])
  .factory('app.shared.clipSortService', [

    function () {
      "use strict";

      let sorter;
      sorter = {

        sort_type: 'game_date',

        sort_direction: -1,

        set_sort_type: (type) => {
          sorter.sort_type = type;
          sorter.sort_direction = sorter.sort_direction * -1;
        },

        get_sort_order: () => {
          let sort_order;

          sort_order = sorter.sort_type + (sorter.sort_direction === 1 ? '_asc' : '_desc');

          return sort_order;
        },

        sort_clips: (feed) => {
          if (feed) {
            feed = angular.copy(feed);

            if (Array.isArray(feed)) {
              let a_cliptime;
              let b_cliptime;

              feed.sort(function (a, b) {
                switch (sorter.get_sort_order()) {
                  case 'game_date_asc':
                    return compare(a.game.dtegametimefixed, b.game.dtegametimefixed);
                  case 'game_date_desc':
                    return compare(b.game.dtegametimefixed, a.game.dtegametimefixed);
                  case 'clip_name_asc':
                    return compare(a.strclipname.toUpperCase(), b.strclipname.toUpperCase());
                  case 'clip_name_desc':
                    return compare(b.strclipname.toUpperCase(), a.strclipname.toUpperCase());
                  case 'matchup_asc':
                    return compare(a.game.league.strleaguenickname, b.game.league.strleaguenickname);
                  case 'matchup_desc':
                    return compare(b.game.league.strleaguenickname, a.game.league.strleaguenickname);
                  case 'category_asc':
                    return compare(a.clip_category.strclipcategory, b.clip_category.strclipcategory);
                  case 'category_desc':
                    return compare(b.clip_category.strclipcategory, a.clip_category.strclipcategory);
                  case 'subcategory_asc':
                    return compare(a.clip_subcategory, b.clip_subcategory);
                  case 'subcategory_desc':
                    return compare(b.clip_subcategory, a.clip_subcategory);
                  case 'clip_time_asc':
                       a_cliptime = parseInt(a.strsourcestart);
                       b_cliptime = parseInt(b.strsourcestart);
                    return compare(a_cliptime, b_cliptime, 'number');
                  case 'clip_time_desc':
                       a_cliptime = parseInt(a.strsourcestart);
                       b_cliptime = parseInt(b.strsourcestart);
                    return compare(b_cliptime, a_cliptime, 'number');
                  case 'clock_time_asc':
                    return compare(a.game_clocktime, b.game_clocktime);
                  case 'clock_time_desc':
                    return compare(b.game_clocktime, a.game_clocktime);
                  case 'duration_asc':
                    return compare(a.strsourceduration, b.strsourceduration);
                  case 'duration_desc':
                    return compare(b.strsourceduration, a.strsourceduration);
                  case 'starred_asc':
                    return compare(a.is_starred, b.is_starred);
                  case 'starred_desc':
                    return compare(b.is_starred, a.is_starred);
                  case 'period_asc':
                    return compare(parseInt(a.iperiod), parseInt(b.iperiod), 'number');
                  case 'period_desc':
                    return compare(parseInt(b.iperiod), parseInt(a.iperiod), 'number');
                }
              });
            }
          }
          return feed;
        }
      };
      return sorter;
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/shared/clipSortService.js